/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React, { CSSProperties } from 'react'
import { Icon } from '../utils/Icon'

export type BookmarkButtonOutlineProps = {
  onClick?: (e: any) => void
  size: number
  style?: CSSProperties
  iconStyle?: CSSProperties
}

export const BookmarkButtonOutline = ({
  onClick,
  size,
  style,
  iconStyle,
}: BookmarkButtonOutlineProps) => {
  return (
    <span
      role="button"
      onClick={onClick}
      style={style}
      css={bookmarkButtonOutlineStyle}
    >
      <Icon
        iconName="map_dialog_like_outline"
        style={{
          display: 'block',
          color: 'rgba(255, 255, 255, 0)', // これがないと、なぜかmap_dialog_like_outline の内側が黒く塗りつぶされてしまう
          height: `${size}px`,
          width: `${size}px`,
          ...iconStyle,
        }}
      />
    </span>
  )
}

const bookmarkButtonOutlineStyle = css`
  cursor: pointer;
`
